<template>
	<vxe-modal v-model="showFlag" title="夜间最小流量分析" :destroy-on-close="true"
					fullscreen remember :esc-closable="true" :mask="false":lock-view="false" show-zoom resize>
		<div class="actDiv">
			<label style="font-size: 0.8rem;">给水号：</label>
			<a-input style="width: 10.5rem;" v-model="theApid"></a-input>
			<label style="font-size: 0.8rem;margin-left: 0.625rem;">日期：</label>
			<a-date-picker  v-model="theDate" style="margin-right: 0.5rem;width: 10.5rem;"
							format="YYYY-MM-DD" :allowClear="false"  @change="dateChangeHandler"/>
			<label style="font-size: 0.8rem;margin-left: 0.625rem;">时段：</label>
			<a-select v-model="beginHour" style="margin-left: 0.5rem;width: 5rem;">
				<a-select-option v-for="item in hourList" :key="item.index" :value="item.index">
					{{item.name}}
				</a-select-option>
			</a-select>
			<label style="font-size: 0.8rem;margin-left: 0.625rem;">至</label>
			<a-select v-model="endHour"  style="margin-left: 0.5rem;width: 5rem;">
				<a-select-option v-for="item in hourList" :key="item.index" :value="item.index">
					{{item.name}}
				</a-select-option>
			</a-select>
			<a-button size="small"   icon="search" @click="doQuery" style="margin: 0 0.5rem;" :loading="loading">查询</a-button>
			<a-button  size="small"  icon="cloud-download"   @click="doExport" >导出</a-button>
			 <a-checkbox @change="onChange" style="margin-left: 0.9375rem;" :disabled="dataList.length==0">
				只看异常
			  </a-checkbox>
		</div>
		<a-table  size="small" :columns="columns" :data-source="dataList" bordered :loading="loading"
						rowKey="id" :pagination="false" :scroll="{y:500}" :hideOnSinglePage="false">
			
			<a-button type="link" slot="theAction" slot-scope="text, record" @click="viewDetail(record)" size="small">
				查看详情
			</a-button>			
			<span slot="theStatus" slot-scope="text, record" :style="getStatusStyle(record.status)">
				{{record.statusStr}}
			</span>
		</a-table>
		<MeterMonitorMinFlowDetail ref="detailView"/>
	</vxe-modal>
</template>

<script>
	const columns = [
		{
			title: '给水号',
			dataIndex: 'meterApid',
			width:120,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '监控点名称',
			dataIndex: 'monitorName',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '监控点地址',
			dataIndex: 'monitorAddress',
			width:200,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '口径',
			dataIndex: 'caliber',
			width:90,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '流量阀值',
			dataIndex: 'overflow',
			width:110,
			className:'v-cell',
			align:'center',
		},
		{
			title: '最小流量',
			dataIndex: 'minFlowData',
			width:110,
			className:'v-cell',
			align:'center',
		},
		{
			title: '状态',
			dataIndex: 'status',
			width:80,
			className:'v-cell',
			align:'center',
			scopedSlots: { customRender: 'theStatus' },
		},
		{
		    title: '操作',
		    key: 'id',
		    scopedSlots: { customRender: 'theAction' },
			width:60,
			className:'v-cell',
			align:'center',
		  },
	];
	import MeterMonitorMinFlowDetail  from "/src/components/MeterMonitorMinFlowDetail.vue"
	export default {
		components: {
			MeterMonitorMinFlowDetail,
		},
		data(){
			return {
				columns,
				showFlag:false,
				theApid:null,
				theDate:null,
				beginHour:0,
				endHour:2,
				loading:false,
				dataList:[],
				tempDataList:[],
			}
		},
		methods: {
			viewDetail(row){
				this.$refs.detailView.showView(row,this.theDate,this.beginHour,this.endHour);
			},
			onChange(e){
				if(!e.target.checked){
					this.dataList = this.tempDataList;
				}else{
					//只看异常的
					let a = [];
					for(var i =0;i<this.tempDataList.length;i++){
						let item = this.tempDataList[i];
						if(item.status == '0'){
							a.push(item);
						}
					}
					this.dataList = a;
				}
			},
			getStatusStyle(status){
				if(status == '1'){
					return {
						color:"#000000",
					}
				}else{
					return {
						color:"#FF0000",
					}
				}
			},
			dateChangeHandler(date,dateString){
				this.theDate = this.$moment(dateString).format('YYYY-MM-DD');
			},
			showView(){
				this.showFlag = true;
				this.theDate = this.$moment().format('YYYY-MM-DD');
				this.doQuery();
			},
			doValid(){
				if(this.theDate == null || this.theDate.length == 0){
					this.$message.error("日期不能为空");
					return false;
				}
				if(this.beginHour == null || this.endHour == null){
					this.$message.error("时段不能为空");
					return false;
				}
				if(this.beginHour >=  this.endHour ){
					this.$message.error("开始时段不能大于等于结束时段");
					return false;
				}
				return true;
			},
			doQuery(){
				if(this.doValid()){
					this.loading = true;
					let param = {
						apId:this.theApid,
						theDate:this.theDate,
						beginHour:this.beginHour,
						endHour:this.endHour,
					};
					let url = this.Api.getLastUrl(this.Api.METER_MONITOR_MIN_FLOW_LIST_URL);
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.loading = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.dataList = result;
							this.tempDataList = result;
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.loading = false;
						console.log(error);
					});
				}
			},
			doExport(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_MIN_FLOW_LIST_EXPORT_URL);
				let param = {
					apId:this.theApid,
					theDate:this.theDate,
					beginHour:this.beginHour,
					endHour:this.endHour,
				};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.loading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '夜间最小流量分析'+'.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		computed: {
			hourList() {
				return [
					{
						name:'0时',
						index:0,
					},
					{
						name:'1时',
						index:1,
					},
					{
						name:'2时',
						index:2,
					},
					{
						name:'3时',
						index:3,
					},
					{
						name:'4时',
						index:4,
					},
					{
						name:'5时',
						index:5,
					},
					{
						name:'6时',
						index:6,
					},
				];
			}
		},
	}
</script>

<style>
</style>
